import { rolesEn } from '@verantos-dev/core-auth';
import {
  appLayoutMessagesEn,
  enterpriseLoginMessagesEn,
  sidebarMessagesEn,
} from '@verantos-dev/core-localization';
import { analysisMessageKeysEn } from '@verantos-dev/feature-analysis';
import { analyticalDatasetsMessageKeysEn } from '@verantos-dev/feature-analytical-datasets';
import { analyticalVariablesMessagesEn } from '@verantos-dev/feature-analytical-variables';
import { avLibraryMessagesEn } from '@verantos-dev/feature-av-library';
import { codeListMapperMessagesEn } from '@verantos-dev/feature-code-mapping';
import { cohortAttritionTableMessagesEn } from '@verantos-dev/feature-cohort-attrition';
import { cohortBuilderPageMessagesEn } from '@verantos-dev/feature-cohort-builder';
import { cohortCharacteristicsMessagesEn } from '@verantos-dev/feature-cohort-characteristics';
import { cohortsListMessageKeysEn } from '@verantos-dev/feature-cohort-list';
import { conceptGroupsMessagesEn } from '@verantos-dev/feature-concept-groups-list';
import { dataReliabilityKeyFn } from '@verantos-dev/feature-data-reliability';
import { epiChatMessagesEn } from '@verantos-dev/feature-epi-chat';
import { organizationsMessagesEn } from '@verantos-dev/feature-organizations-list';
import { projectPageMessageKeysEn } from '@verantos-dev/feature-project-page';
import { projectsListMessageKeysEn } from '@verantos-dev/feature-projects-list';
import { raSessionReviewKeyFn } from '@verantos-dev/feature-ra-session-review';
import { researchAssistantMessagesEn } from '@verantos-dev/feature-research-assistant';
import { cohortBuilderSubjectsListMessagesEn } from '@verantos-dev/feature-subjects-list';
import { usersMessagesEn } from '@verantos-dev/feature-users-list';
import { dataGridMessagesEn } from '@verantos-dev/shared-components';

import { sharedLocale } from './shared.en';
export default {
  ...sharedLocale,
  ...appLayoutMessagesEn,
  ...sidebarMessagesEn,
  ...enterpriseLoginMessagesEn,
  ...dataGridMessagesEn,
  ...usersMessagesEn,
  ...projectPageMessageKeysEn,
  ...projectsListMessageKeysEn,
  ...cohortBuilderPageMessagesEn,
  ...cohortAttritionTableMessagesEn,
  ...cohortBuilderSubjectsListMessagesEn,
  ...cohortCharacteristicsMessagesEn,
  ...researchAssistantMessagesEn,
  ...analyticalVariablesMessagesEn,
  ...analyticalDatasetsMessageKeysEn,
  ...organizationsMessagesEn,
  ...cohortsListMessageKeysEn,
  ...dataReliabilityKeyFn,
  ...raSessionReviewKeyFn,
  ...rolesEn,
  ...conceptGroupsMessagesEn,
  ...avLibraryMessagesEn,
  ...codeListMapperMessagesEn,
  ...epiChatMessagesEn,
  ...analysisMessageKeysEn,
};
